<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px;">
      <div class="modal-header">
        <div class="title">详情</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 400px;" v-loading="loading">


        <div v-if="data !=null">


          <el-row>
            <el-col :span="24" class="item">
              <el-steps :space="200" :active="data.orderBusiness.status-10" finish-status="success">
                <el-step title="待付款"></el-step>
                <el-step title="待接单"></el-step>
                <el-step title="待服务"></el-step>
                <el-step title="服务中"></el-step>
                <el-step title="已完成"></el-step>
                <el-step title="已取消"></el-step>
                <el-step title="已评价"></el-step>
                <el-step title="已退单"></el-step>
              </el-steps>
            </el-col>
          </el-row>


          <div style="border: 1px solid #ddd;margin: 20px;">

            <div>
              <div style="float:left;width: 14%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">服务对象</div>
              </div>
              <div style="float:left;width: 35%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">{{data.order.receiveName}}</div>
              </div>
              <div style="float:left;width: 15%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">服务人员</div>
              </div>
              <div style="float:left;width: 35%;">
                <div style="padding: 10px;" v-if="data.orderServeDTO !=null">{{data.orderServeDTO.userDTO.name}}</div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd;">
              <div style="float:left;width: 14%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">服务项目</div>
              </div>
              <div style="float:left;width: 85%;">
                <div style="padding: 10px;">
                  <span v-for="(item,index) in data.listOrderGoodsDTO" :key="index">
                    {{item.goodsName}}
                  </span>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd; ">
              <div style="float:left;width: 14%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">服务开始时间</div>
              </div>
              <div style="float:left;width: 35%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">
                  <div v-if="data.orderServeRecordDTOStart !=null">{{timefilter2(data.orderServeRecordDTOStart.createTime)}}</div>
                  <div v-else>-</div>
                </div>
              </div>
              <div style="float:left;width: 15%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">服务结束时间</div>
              </div>
              <div style="float:left;width: 35%;">
                <div style="padding: 10px;">
                  <div v-if="data.orderServeRecordDTOEnd !=null">{{timefilter2(data.orderServeRecordDTOEnd.createTime)}}</div>
                  <div v-else>-</div>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd; ">
              <div style="float:left;width: 14%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">工单状态</div>
              </div>
              <div style="float:left;width: 85%;">
                <div style="padding: 10px;">
                  <div v-if="data.orderBusiness.status =='10' ">待付款</div>
                  <div v-if="data.orderBusiness.status =='11' ">待接单</div>
                  <div v-if="data.orderBusiness.status =='12' ">待开始</div>
                  <div v-if="data.orderBusiness.status =='13' ">待结束</div>
                  <div v-if="data.orderBusiness.status =='14' ">待评价</div>
                  <div v-if="data.orderBusiness.status =='15' ">已取消</div>
                  <div v-if="data.orderBusiness.status =='16' ">已评价</div>
                  <div v-if="data.orderBusiness.status =='17' ">已退单</div>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd; ">
              <div style="float:left;width: 14%;">
                <div style="padding: 10px;">服务开始前照片</div>
              </div>
              <div style="float:left;width: 85%;border-left: 1px solid #ddd;">
                <div style="padding: 10px;">
                  <div v-if="data.orderServeRecordDTOStart != null">

                     <span v-for="(item,index) in data.orderServeRecordDTOStart.listOrderServeRecordImg" :key="index">
                       <el-popover placement="right" trigger="click">
                        <img :src="imgHost+item.imgPath+'_watermark.jpg'" style="width: 400px"/>
                        <img slot="reference" :src="imgHost+item.imgPath+'_watermark.jpg'" style="width:100px;margin-right: 10px">
                       </el-popover>
                    </span>

                  </div>
                  <div v-else>-</div>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd; ">
              <div style="float:left;width: 14%;">
                <div style="padding: 10px;">服务结束时照片</div>
              </div>
              <div style="float:left;width: 85%;border-left: 1px solid #ddd;">
                <div style="padding: 10px;">
                  <div v-if="data.orderServeRecordDTOEnd != null">

                     <span v-for="(item,index) in data.orderServeRecordDTOEnd.listOrderServeRecordImg" :key="index">
                       <el-popover placement="right" trigger="click">
                        <img :src="imgHost+item.imgPath+'_watermark.jpg'" style="width: 400px"/>
                        <img slot="reference" :src="imgHost+item.imgPath+'_watermark.jpg'" style="width:100px;margin-right: 10px">
                       </el-popover>
                    </span>

                  </div>
                  <div v-else>-</div>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd; ">
              <div style="float:left;width: 14%;border-right: 1px solid #ddd;">
                <div style="padding: 10px;">服务评价</div>
              </div>
              <div style="float:left;width: 85%;">
                <div style="padding: 10px;">
                  <div v-if="data.orderBusinessAppraise != null">
                    <span>{{data.orderBusinessAppraise.remarks}}</span>
                    <el-button v-if="data.orderBusinessAppraise.amrPath != null && data.orderBusinessAppraise.amrPath != ''" size="mini"
                               @click="playAudio(data.orderBusinessAppraise.amrPath)"
                               style="padding: 2px">播放>></el-button>
                  </div>
                  <div v-else>-</div>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

            <div style="border-top:1px solid #ddd; ">
              <div style="float:left;width: 14%;">
                <div style="padding: 10px;">服务评价签字</div>
              </div>
              <div style="float:left;width: 85%;border-left: 1px solid #ddd;">
                <div style="padding: 10px;">
                  <span v-if="data.orderBusinessAppraise !=null">
                       <el-popover placement="right" trigger="click">
                        <img :src="imgHost+data.orderBusinessAppraise.signPath+'_2000x2000.jpg'" style="width: 400px"/>
                        <img slot="reference" :src="imgHost+data.orderBusinessAppraise.signPath+'_310x310.jpg'" style="width:60px">
                      </el-popover>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>

          </div>



        </div>


      </div>
    </div>

  </div>
</template>


<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import BenzAMRRecorder from "benz-amr-recorder";

export default {
  name: 'Add',
  data() {
    return {

      loading: false,

      orderBusinessCode:'',

      data:null,

      imgHost:this.$imgUrl,

    }
  },
  methods: {

    init(orderBusinessCode){
      this.orderBusinessCode = orderBusinessCode;
      this.getDetail();

    },
    closeSelf() {
      this.$emit("closeInfo");
    },


    getDetail(){

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusiness/OrderDetail2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          orderBusinessCode: this.orderBusinessCode,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error === 0) {
          this.data = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },

    timefilter2(cellValue) {
      if(cellValue == null){
        return '-';
      }
      return timefilters(cellValue)
    },

    // 音频播放
    playAudio(url) {
      //this.mediaUrl = url

      let ss = url.substring(url.indexOf("/files/"));
      url = this.imgHost + ss;
      console.log(url);

      if(this.isPlay){
        this.isPlay = false
        if(this.amr.isPlaying()){
          this.amr.stop();//停止
        }
      }
      else{
        var BenzAMRRecorder = require('benz-amr-recorder');
        this.amr = new BenzAMRRecorder();
        this.isPlay = true
        this.amr.initWithUrl(url).then(()=> {
          this.amr.play();
        });
        this.amr.onEnded(()=> {
          this.isPlay = false
        })
      }

    },


  }
}
</script>


